"use client";

import dynamic from "next/dynamic";

const FAQList = dynamic(() => import("./FAQList").then(mod => mod.FAQList));

export default FAQList;
